import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { sessions } from '../data/OfferingData';
import { Breadcrumb } from '../../../Components/Breadcrumb';
import OrangeButton from '../../../Components/buttons/orange-button';
import HeaderAlt from '../../../Components/HeaderAlt';

import { Footer } from '../../../Components/Footer';
import SignUpPopup from '../../tutor-details/components/SignupPopup';
import CustomModal from '../../../Components/CustomModal';

const OfferingDetailPage = () => {
  const { id } = useParams();
  const [isSignupOpen, setIsSignupOpen] = useState(false);

  //   const [showBookingModal, setShowBookingModal] = useState(false);
  const selectedOffer = sessions?.find((session) => session.id === id);

  //   function onModalCLose() {
  //     setShowBookingModal(false);
  //     setStep(1);
  //     setSelectedTime(new Date());
  //     setSelectedDate(null);
  //   }

  const breadcrumbItems = [
    { label: 'Discover Sessions', href: '/' },
    { label: '', href: '' },
  ];

  // if (loading) {
  //   return (
  //     <div className="flex h-full items-center justify-center">
  //       <div className=" loader"></div>
  //     </div>
  //   );
  // }
  return (
    <>
      <HeaderAlt />
      <div className="container !mb-16 !mt-6">
        {/* <CustomModalBooking
        isOpen={showBookingModal}
        onClose={onModalCLose}
        className={'!w-[680px] '}
      >
        <BookingModal
          setStep={setStep}
          step={step}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
          tutorname={selectedOffer?.tutorFirstName}
          setShowBookingModal={setShowBookingModal}
          setIsBooked={setIsBooked}
        />
      </CustomModalBooking> */}
        <Breadcrumb items={breadcrumbItems} />
        <div className="mt-2 flex gap-6">
          <div className="flex-1 ">
            <div className="flex flex-col gap-3">
              <h1 className="text-4xl font-semibold leading-[150%] text-teal-900">
                {selectedOffer?.title}
              </h1>
              <div className="flex gap-4">
                <div className="flex items-center gap-[14px]">
                  <img src="/images/icons/users-group.svg" alt="" className="size-4" />
                  <span className="text-base font-medium text-gray-500">
                    {selectedOffer?.totalEnrolls} students enrolled
                  </span>
                </div>

                <div className="flex items-center gap-[14px]">
                  <img src="/images/icons/videocamera-teal.svg" alt="" className="size-4" />
                  <span className="text-base font-medium text-gray-500">
                    Virtual Individual Session
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <span className="text-xl leading-[150%] text-[#6B7280]">
                {selectedOffer?.studentDes + selectedOffer?.studentDes}
              </span>
            </div>
            <div className="mt-4">
              <div className="flex flex-col gap-[18px]">
                <span className="text-base font-medium text-gray-500">Hosted By</span>
                <div className="flex gap-4">
                  <div className="size-14 rounded-full ">
                    <img
                      src={selectedOffer?.tutorProgfileImg}
                      className="size-full rounded-full"
                      alt=""
                    />
                  </div>
                  <div className="flex-1">
                    <span className="text-base font-semibold text-teal-900">
                      {selectedOffer?.tutorFirstName} {selectedOffer?.tutorLastName}
                    </span>
                    <p className="mt-1 text-base text-gray-400">{selectedOffer?.bio} </p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="mt-[26px] bg-gray-200" />
            <div className="mt-6 flex flex-col gap-4">
              <h2 className="fredokaOne text-lg text-teal-900">What to expect in this session?</h2>
              <p className="text-base text-[#6B7280]">
                {selectedOffer?.instruction}
                {selectedOffer?.instruction}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center gap-4">
            <div className=" customShadow w-[392px] rounded-2xl">
              <img src={selectedOffer?.imgUrl} alt="" className="w-full rounded-xl" />

              <div className="mb-[24px] mt-[24.5px] flex flex-col px-4 ">
                <span className="mb-2 text-base font-medium text-gray-500">Virtual Session</span>
                <div className="flex w-full items-center justify-between">
                  <div className="flex items-center gap-2">
                    <img src="/images/icons/dollar-teal.svg" alt="" className="size-6" />
                    <span className="text-2xl font-semibold leading-[150%] text-teal-900">
                      {selectedOffer?.price}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <img src="/images/icons/clock-outline-teal.svg" alt="" className="size-6" />
                    <span className="text-2xl font-semibold leading-[150%] text-teal-900">
                      {selectedOffer?.time}
                    </span>
                  </div>
                </div>
              </div>
              <div className="mb-4 flex flex-col gap-4 px-4">
                <OrangeButton
                  //   icon={isBooked && '/icons/thumbs-up.svg'}
                  iconClassName="!size-[14px]"
                  disable
                  label={'Create an Account to book'}
                  className={`fredokaOne !items-center !gap-2 !rounded-lg !text-base !font-normal !shadow-none`}
                  // disabled={isBooked}
                  onClick={() => setIsSignupOpen(true)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomModal
        className="max-w-[480px]"
        isOpen={isSignupOpen}
        onClose={() => setIsSignupOpen(false)}
      >
        <SignUpPopup />
      </CustomModal>
      <Footer />
    </>
  );
};

export default OfferingDetailPage;
